<template>
  <div class="loadingio-spinner-rolling u-mbm">
    <SVGIcon class="loading-icon" width="80" height="80" name="loading" />
  </div>
</template>

<script setup lang="ts">
import SVGIcon from '@/components/SVGIcon.vue'

</script>

<style scoped>
/* generated by https://loading.io/ */
@keyframes ldio {
  0% { transform: translate(-50%,-50%) rotate(0deg); }
  100% { transform: translate(-50%,-50%) rotate(360deg); }
}

.ldio div {
  position: absolute;
  width: 60px;
  height: 60px;
  border: 10px solid #30b2f2;
  border-top-color: transparent;
  border-radius: 50%;
  box-sizing: content-box;
  animation: ldio 1s linear infinite;
  top: 50px;
  left: 50px
}

.loadingio-spinner-rolling {
  width: 100px;
  height: 100px;
  margin-left: auto;
  margin-right: auto;
  display: block;
  overflow: hidden;
  background: none;
}

.ldio {
  width: 100%;
  height: 100%;
  position: relative;
  transform: translateZ(0) scale(1);
  backface-visibility: hidden;
  transform-origin: 0 0;
}
</style>
